import React from "react";
import EmandateInfoPage from "../Mandate/EmandateInfoPage";
import resumeSip from "@frameworks/shared-library/assets/images/SalesJourney/resume-sip.svg";
var ResumeOrder = function () {
    return (React.createElement("div", { className: "parent-order-info-container commonscroll" },
        React.createElement("main", { className: "d-flex flex-column align-items-center container-content-top status-container" },
            React.createElement("div", { className: "d-flex flex-column align-items-center gap-4" },
                React.createElement(EmandateInfoPage, { iconSrc: resumeSip, title: "Do you want to resume this SIP?", description: "Pick up where you left off and keep growing your investment." })))));
};
export default ResumeOrder;
